import * as React from 'react';

interface Props {}

export const EcardSVG: React.SFC<Props> = ({}) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.6" cx="20" cy="20" r="20" fill="#DFE8EC" />
      <path
        d="M11.8121 17.3C12.5 16.5 11.2104 17.7468 11.0895 18.0209C11.0307 18.1541 11 18.4999 11.0024 18.4429V28.3429C10.9795 28.7525 11.1223 29.1546 11.4002 29.4625C11.678 29.7705 12.0686 29.9599 12.4881 29.9899H27.5119C27.9313 29.9599 28.322 29.7705 28.5998 29.4625C28.8777 29.1546 29.0205 28.7525 28.9976 28.3429V18.6139C29.0009 18.4415 28.9635 18.2707 28.8883 18.1147C28.8131 17.9586 28.1503 17.4075 28.0121 17.3"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4388 22.736L12.4388 11.819C12.4388 11.3667 12.8055 11 13.2578 11L26.7431 11C27.1955 11 27.5621 11.3667 27.5621 11.819V22.736"
        stroke="#333333"
        strokeMiterlimit="10"
      />
      <path
        d="M27.7151 29.2653L21.1721 23.1723C20.8527 22.869 20.429 22.7 19.9886 22.7C19.5481 22.7 19.1245 22.869 18.8051 23.1723L12.2621 29.2653"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15.2893 25.85L11.5004 21.917" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M24.2961 25.868L28.913 21.35" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d={`M23.2014 16.8789C23.2014 17.2773 23.1378 17.6426 23.0105 17.9746C22.8832 18.3039 22.7034 18.5626 22.4709 18.7507C22.2385 18.9389
         21.9688 19.033 21.6616 19.033C21.4569 19.033 21.2756 18.9845 21.1179 18.8877C20.9602 18.7881 20.8468 18.658 20.7776 18.4976H20.7112C20.4124
          18.8545 20.0319 19.033 19.5698 19.033C19.0801 19.033 18.6941 18.8863 18.4119 18.593C18.1296 18.297 17.9885 17.893 17.9885 17.3811C17.9885
           16.7973 18.1739 16.3269 18.5447 15.97C18.9154 15.613 19.3997 15.4346 19.9973 15.4346C20.2353 15.4346 20.4967 15.4581 20.7817 15.5051C21.0695
            15.5494 21.3061 15.6034 21.4915 15.667L21.396 17.6965C21.396 18.0811 21.5011 18.2734 21.7114 18.2734C21.8885 18.2734 22.0296 18.1448 22.1348
             17.8875C22.2399 17.6274 22.2925 17.2884 22.2925 16.8706C22.2925 16.4251 22.1998 16.0322 22.0144 15.6919C21.829 15.3488 21.5675 15.0873 21.23
              14.9075C20.8952 14.7276 20.512 14.6377 20.0803 14.6377C19.5214 14.6377 19.0358 14.7525 18.6235 14.9822C18.2113 15.2118 17.8944 15.5439
               17.6731 15.9783C17.4545 16.4099 17.3452 16.9093 17.3452 17.4766C17.3452 18.2402 17.5486 18.8268 17.9553 19.2363C18.3648 19.6431
                18.9569 19.8464 19.7317 19.8464C20.025 19.8464 20.3473 19.8146 20.6987 19.751C21.0501 19.6846 21.396 19.5891 21.7363 19.4646V20.2615C21.1442
                 20.5133 20.4871 20.6392 19.7649 20.6392C18.7135 20.6392 17.8931 20.3625 17.3037 19.8091C16.7171 19.2557 16.4238 18.4865 16.4238 17.5015C16.4238
                  16.818 16.5732 16.1982 16.8721 15.6421C17.1737 15.0832 17.6012 14.646 18.1545 14.3306C18.7107 14.0124 19.3499 13.8533 20.072 13.8533C20.6807
                   13.8533 21.2244 13.9778 21.7031 14.2268C22.1818 14.4758 22.5512 14.83 22.8113 15.2893C23.0714 15.7486 23.2014 16.2785 23.2014
                    16.8789ZM18.9514 17.3977C18.9514 17.9815 19.1894 18.2734 19.6653 18.2734C19.9143 18.2734 20.1038 18.1863 20.2339 18.012C20.3639
                     17.8349 20.4428 17.5485 20.4705 17.1528L20.5244 16.2356C20.3833 16.2052 20.2242 16.1899 20.0471 16.1899C19.7013 16.1899 19.4315 16.2979 19.2378 16.5137C19.0469 16.7295 18.9514 17.0242 18.9514 17.3977Z`}
        fill="#333333"
      />
    </svg>
  );
};
